import { createSlice } from "@reduxjs/toolkit";
import { getClaimById } from "../../reducer/claims/claimsReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const claimByIdSlice = createSlice({
  name: "claimById",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClaimById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getClaimById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(getClaimById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default claimByIdSlice.reducer;
